import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 20223-09-11
 * @brief SEI 사업장 관리 개발
 *
 ********************************************************************/
import { useState } from "react";
//component
import { useOutletContext } from "react-router-dom";
import SiteCRUD from "./SiteCRUD";
import SiteTree from "./SiteTree";
function SiteMain() {
    // props
    const { handleOpenPop } = useOutletContext();
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH
    const [workMode, setWorkMode] = useState("READ");
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx(SiteTree, { workMode: workMode, setWorkMode: setWorkMode }), _jsx(SiteCRUD, { workMode: workMode, setWorkMode: setWorkMode, handleOpenPop: handleOpenPop })] })) }));
}
export default SiteMain;
